import { render, staticRenderFns } from "./ChartArrow.vue?vue&type=template&id=05580122&scoped=true"
import script from "./ChartArrow.vue?vue&type=script&lang=js"
export * from "./ChartArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05580122",
  null
  
)

export default component.exports